import React from 'react';
import { makeStyles } from '@mui/styles';
import AutoPlaySwipeableViews from '@Common/quillElements/AutoPlaySwipeableViews';

const examplesData = [
  {
    id: 1,
    input:
      'If you’re going to South America, you’ve got to check out Brazil. It’s the largest, most populated country on the continent. Plus, the rich culture and bustling cities will ensure your trip is exciting.',
    output:
      'Brazil is a must-see destination in South America, both for its vibrant culture and for the variety of landscapes to explore.',
  },
  {
    id: 2,
    input:
      'The first thing I do when I wake up is make my bed. After that, I’ll go downstairs and pour some orange juice to go along with my waffles. When I’m finished eating, I change out of my pajamas and into my suit. Lastly, I brush my teeth.',
    output:
      'When I wake up in the morning, I make my bed first before going downstairs to cook breakfast. Then, I get dressed for work and brush my teeth.',
  },
  {
    id: 3,
    input:
      'In order to truly understand the stock market, you’ve got to get a degree in finance or business. Then, you should spend some time analyzing Wall Street and invest in stocks yourself. After that, you can make serious money as a broker.',
    output: 'Making money with stocks starts with a good education and hands-on experience.',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '60px 15px 23px',
    maxWidth: 665,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: '60px 32px 23px',
    },
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    margin: '0 0 20px',
  },
  text: {
    fontSize: 16,
  },
  sliderWrapper: {
    maxWidth: 876,
    margin: '0 auto',
    position: 'relative',
  },
  // dot: {
  //   width: 5,
  //   height: 5,
  // },
  dotActive: {
    width: 18,
    borderRadius: 50,
  },
  dotsWrapper: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  swiperSlide: {
    padding: '18px 18px 34px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    borderRadius: 9,
    margin: '17px auto 26px',
    maxWidth: 665,
    [theme.breakpoints.down('sm')]: {
      minHeight: 390,
      margin: '17px 16px 26px',
    },
  },
  inputWrapper: {
    padding: '18px 20px 24px',
    backgroundColor: theme.palette.background.default,
    borderRadius: 2,
  },
  outputWrapper: {
    padding: '18px 20px 24px',
    backgroundColor: '#CCEDFF',
    borderRadius: 2,
    marginTop: 18,
  },
  slideLabel: {
    fontWeight: 700,
    marginBottom: 8,
  },
  slideText: {},
  outputText: {
    fontSize: 20,
    fontWeight: 600,
  },
}));

function Examples() {
  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
        <h2 className={classes.title}>Paraphrasing Examples</h2>
        <div className={classes.text}>
          We’re big believers in learning by doing, so let’s take a look at some examples of
          paraphrasing. Seeing the process in action will help you understand how it works.
        </div>
      </div>
      <div className={classes.sliderWrapper}>
        <AutoPlaySwipeableViews
          autoplay={false}
          mobileStepperClasses={{
            dotActive: classes.dotActive,
            dots: classes.dotsWrapper,
          }}
          mobileStepperStyle={{ backgroundColor: 'transparent' }}
          // mobileStepperContainerStyle={{ display: 'none' }}
        >
          {examplesData.map((item) => (
            <div key={item.id} className={classes.swiperSlide}>
              <div className={classes.inputWrapper}>
                <div className={classes.slideLabel}>Input</div>
                <div className={classes.slideText}>{item.input}</div>
              </div>
              <div className={classes.outputWrapper}>
                <div className={classes.slideLabel}>Output</div>
                <div className={classes.outputText}>{item.output}</div>
              </div>
            </div>
          ))}
        </AutoPlaySwipeableViews>
      </div>
    </>
  );
}

export default Examples;
